import React from "react";
import Spinner from "react-bootstrap/Spinner";

export const Loader = ({ type = "textOnly", style = {} }) => (
  <div
    style={{
      ...style,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    {type === "textOnly" ? (
      <>
        <div className="custom-loader">Loading...</div>
      </>
    ) : (
      <>
        <Spinner animation="border" role="status" />
      </>
    )}
  </div>
);
